module.exports = __webpack_public_path__ + "media/images/cplook/mstile-70x70-174c433ff67a6c3bc8055e9c568ae8f3.png";